module.exports = __webpack_public_path__ + "static/media/LK_White_Search.5325d30c.svg";